import { configureStore } from "@reduxjs/toolkit";
import sleepSlice from "./sleepSlice";

export default configureStore({
    reducer: {
        sleepCalc: sleepSlice
    }
})